import {colors} from '../maps/colors';
import styled from "styled-components";

const PageTitleStyled = styled.div`
  color: ${colors.GREEN};
  font-size: 24px;
  font-weight: 500;
  padding: 20px 0;

  svg {
    vertical-align: text-top;
  }
`;

function PageTitle(props) {
    return <PageTitleStyled>{props.children}</PageTitleStyled>;
}

export default PageTitle;